import { render, staticRenderFns } from "./IconRoboClock.vue?vue&type=template&id=94f6f4f2&scoped=true&"
import script from "./IconRoboClock.vue?vue&type=script&lang=js&"
export * from "./IconRoboClock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94f6f4f2",
  null
  
)

export default component.exports